class ShareButton extends HTMLElement {
  constructor() {
    super();
    this.shareLinks = {
      whatsapp: this.querySelector('a[href*="wa.me"]'),
      facebook: this.querySelector('a[href*="facebook.com"]'),
      tiktok: this.querySelector('a[href*="tiktok.com"]'),
      instagram: this.querySelector('a[href*="instagram.com"]'),
      copy: this.querySelector('button[onclick]')
    };
  }

  connectedCallback() {
    // Copy button
    if (this.shareLinks.copy) {
      this.shareLinks.copy.addEventListener('click', () => {
        navigator.clipboard.writeText(this.currentUrl)
          .then(() => this.showCopiedMessage());
      });
    }
  }

  updateUrl(url) {
    // Save the current URL to use in share links
    this.currentUrl = url;

    // Update WhatsApp share
    if (this.shareLinks.whatsapp) {
      this.shareLinks.whatsapp.href = `https://wa.me/?text=${encodeURIComponent(url)}`;
    }

    // Update Facebook share
    if (this.shareLinks.facebook) {
      this.shareLinks.facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    }

    // TikTok and Instagram don't have direct share URLs
    if (this.shareLinks.tiktok) {
      this.shareLinks.tiktok.href = `https://www.tiktok.com/`;
    }
    if (this.shareLinks.instagram) {
      this.shareLinks.instagram.href = `https://www.instagram.com/`;
    }
  }

  showCopiedMessage() {
    const msg = document.createElement('div');
    msg.innerText = 'Copied to clipboard!';
    msg.style.position = 'fixed';
    msg.style.bottom = '20px';
    msg.style.right = '20px';
    msg.style.background = '#000';
    msg.style.color = '#fff';
    msg.style.padding = '8px 12px';
    msg.style.borderRadius = '4px';
    msg.style.zIndex = '9999';
    msg.style.opacity = '0';
    msg.style.transition = 'opacity 0.3s ease';
    document.body.appendChild(msg);
    requestAnimationFrame(() => msg.style.opacity = '1');
    setTimeout(() => {
      msg.style.opacity = '0';
      setTimeout(() => msg.remove(), 300);
    }, 2000);
  }
}

customElements.define('share-button', ShareButton);
